import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './errors.ts';

/** Claves de TanStack Query (una fuente para invalidar después de pagar, devolver, etc.). */
export const queryKeys = {
  me: ['me'] as const,
  lines: ['credit', 'lines'] as const,
  line: (lineId: string) => ['credit', 'lines', lineId] as const,
  drawdowns: (lineId: string) => ['credit', 'lines', lineId, 'drawdowns'] as const,
  movements: (lineId: string, type: string) =>
    ['credit', 'lines', lineId, 'movements', type] as const,
  statements: (lineId: string) => ['credit', 'lines', lineId, 'statements'] as const,
  statement: (lineId: string, statementId: string) =>
    ['credit', 'lines', lineId, 'statements', statementId] as const,
  frequentPayees: ['payees', 'frequent'] as const,
  paymentIntent: (id: string) => ['payment-intents', id] as const,
  receipt: (id: string) => ['receipts', id] as const,
  disputes: ['disputes'] as const,
  refunds: ['refunds'] as const,
  application: ['applications', 'current'] as const,
  offer: (applicationId: string) => ['applications', applicationId, 'offer'] as const,
  voiceConfig: ['agent', 'voice', 'config'] as const,
};

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // No reintenta errores de negocio (4xx): solo fallas transitorias.
        retry: (count, error) => count < 2 && !(isApiError(error) && error.status < 500),
      },
      mutations: { retry: false },
    },
  });
}
